import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { FinanciacionPrivadaModel } from './financiacion-privada.model';
import { FinanciacionPrivadaService } from './financiacion-privada.service';

@Component({
    selector: 'convfact-financiacion-privada',
    templateUrl: './financiacion-privada.component.html',
    styleUrls: ['./financiacion-privada.component.css'],
    standalone: false
})

export class FinanciacionPrivadaComponent implements OnInit {

  public financiacionPrivada = new FinanciacionPrivadaModel;
  public spinner: boolean = false;
  public ready: boolean = false;
  public spinnerMessage: string = 'Cargando financiación privada…';

  constructor(
    private financiacionPrivadaService: FinanciacionPrivadaService,
    public snackBar: MatSnackBar,
    private router: Router
  ) { }

  public ngOnInit(): void {
    const temp = this.router.url.split('/');
    this.spinner = true;
    if (temp.length == 6) {
      const uid = temp[5];
      this.financiacionPrivadaService.get(uid)
        .then(response => {
          if (response) {
            this.financiacionPrivada = response;
          }
          this.spinner = false;
          this.ready = true;
        })
        .catch(error => {
          this.spinner = false;
          this.displayError(this.serverMessage(error) || "No se pudo cargar la financiación privada");
          this.returnToIndex();
        });
    }
    else {
      this.spinner = false;
      this.ready = true;
    }

  }

  public saveData(financiacionPrivada: FinanciacionPrivadaModel): void {
    if (this.spinner) {
      return;
    }

    this.spinnerMessage = 'Guardando financiación privada…';
    this.spinner = true;

    if (financiacionPrivada.uid == null) {
      this.financiacionPrivadaService.add(financiacionPrivada)
        .then(response => {
          this.spinner = false;
          this.returnToIndex();
        })
        .catch(error => {
          this.spinner = false;
          this.displayError(this.serverMessage(error) || "Ha ocurrido un error inesperado al crear la financiación privada");
        })
    } else {
      this.financiacionPrivadaService.edit(financiacionPrivada)
        .then(response => {
          this.spinner = false;
          this.returnToIndex();
        })
        .catch(error => {
          this.spinner = false;
          this.displayError(this.serverMessage(error) || "Ha ocurrido un error inesperado al actualizar la financiación privada")
        })
    }
  }

  public displayError(error: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    options.panelClass = ['snack-error'];
    this.snackBar.open(error, '', options);
  }

  public returnToIndex(): void {
    this.router.navigate(['finance/loans/privatefinancing']);
  }

  private serverMessage(error: any): string {
    return (error && error.error && error.error.message) || '';
  }

}
